'use client';

import PaginatedGrid from '@repo/ui/src/components/PaginatedGrid';
import MeaterGridItem from './_MeaterGridItem';
import type { MeaterProduct } from '@src/domain/types/MeaterProduct';

interface MeaterProductGridProps {
  _data?: Array<MeaterProduct>;
  content?: {
    noResultsContent?: {
      title?: string;
      text?: string;
      image?: { url?: string };
    };
  };
}

const MeaterProductGrid = ({ _data, content }: MeaterProductGridProps) => {
  return (
    <PaginatedGrid
      items={_data ?? []}
      content={content}
      GridItemComponent={MeaterGridItem}
      itemClassName="border border-warm-200 bg-white"
    />
  );
};

export default MeaterProductGrid;
